module.exports = __webpack_public_path__ + "img/home.da4dcddf.svg";